/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Program_LengthInputs */

const en_subtitle_export_program_length = /** @type {(inputs: Subtitle_Export_Program_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Program Length`)
};

const fr_subtitle_export_program_length = /** @type {(inputs: Subtitle_Export_Program_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée du programme`)
};

const de_subtitle_export_program_length = /** @type {(inputs: Subtitle_Export_Program_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programmlänge`)
};

const it_subtitle_export_program_length = /** @type {(inputs: Subtitle_Export_Program_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durata del programma`)
};

const ru_subtitle_export_program_length = /** @type {(inputs: Subtitle_Export_Program_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Длительность программы`)
};

const es_subtitle_export_program_length = /** @type {(inputs: Subtitle_Export_Program_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración del programa`)
};

const zh_cn2_subtitle_export_program_length = /** @type {(inputs: Subtitle_Export_Program_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`节目时长`)
};

const ja_subtitle_export_program_length = /** @type {(inputs: Subtitle_Export_Program_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プログラムの長さ`)
};

const hi_subtitle_export_program_length = /** @type {(inputs: Subtitle_Export_Program_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्यक्रम की अवधि`)
};

const pt_pt2_subtitle_export_program_length = /** @type {(inputs: Subtitle_Export_Program_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração do programa`)
};

/**
* | output |
* | --- |
* | "Program Length" |
*
* @param {Subtitle_Export_Program_LengthInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_program_length = /** @type {((inputs?: Subtitle_Export_Program_LengthInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Program_LengthInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_program_length(inputs)
	if (locale === "de") return de_subtitle_export_program_length(inputs)
	if (locale === "it") return it_subtitle_export_program_length(inputs)
	if (locale === "ru") return ru_subtitle_export_program_length(inputs)
	if (locale === "es") return es_subtitle_export_program_length(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_program_length(inputs)
	if (locale === "ja") return ja_subtitle_export_program_length(inputs)
	if (locale === "hi") return hi_subtitle_export_program_length(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_program_length(inputs)
	return en_subtitle_export_program_length(inputs)
});